document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("csq-questionnaire-form");

  if (form === null) {
    return;
  }

  const dropdownButton = document.getElementById("step-toggle-button");
  const dropdownList = document.getElementById("step-toggle-menu");

  window.addEventListener("click" , (e) => {
    if (e.target.id === "step-toggle-menu" || e.target.closest("#step-toggle-menu") !== null || dropdownList.style.display !== "block") {
      return;
    }

    dropdownList.style.display = "none";
  });

  dropdownButton.addEventListener("click" , (e) => {
    e.stopPropagation();

    if (dropdownList.style.display === "none") {
      dropdownList.style.display = "block";
    } else {
      dropdownList.style.display = "none";
    }
  });
});
